<template>
  <div class="prizes">
    <div class="container">
      <ul v-for="(rank, index) in currentPrizes" v-bind:key="`rank_${index}`">
        <li class="rank_title" v-bind:class="[rankColor(index)]">
          <img :src="rankTitle(index)" />
        </li>
        <li
          class="rank_item_container"
          v-bind:class="[{ freepass_container: prize.last_of_rank }]"
          v-for="(prize, idx) in rank"
          v-bind:key="`prize_${idx}`"
        >
          <div
            class="rank_item"
            v-bind:class="[{ freepass: prize.last_of_rank }]"
          >
            <div
              class="image"
              :style="{ backgroundImage: 'url(' + prize.thumb_url + ')' }"
            ></div>
            <div class="detail">
              <div class="title">
                <div>
                  <span class="icon-stamp"
                    ><span class="bold"
                      >スタンプ累計{{ prize.num_needed }}個で</span
                    ></span
                  >
                </div>
              </div>
              <div class="caption">{{ prize.caption }}</div>
            </div>
          </div>
          <hr
            v-if="
              !prize.last_of_rank &&
                rank[idx + 1] &&
                !rank[idx + 1].last_of_rank
            "
          />
        </li>
      </ul>
      <p v-if="currentPrizes.length > 0">
        ※ダイヤモンドカード達成後は、ボーナスカードが表示されます。10スタンプごとに、フリーパスを除くダイヤモンドカード特典が繰り返されます。
      </p>
    </div>
  </div>
</template>

<script>
import { FactoryTrack } from '../constant/firebase.js'
import { mapActions, mapGetters } from 'vuex'

import DateFormatter from '../utils/DateFormatter.js'

export default {
  name: 'Prizes',
  components: {},
  data: function() {
    return {
      currentPrizes: []
    }
  },
  created() {
    document.title = '特典一覧'
    const accTime = new DateFormatter().format(new Date())
    try {
      window.receivedToken = payload => {
        const json = JSON.parse(payload)
        this.fetchPrizeList(json.app_token, accTime, json.user_id)
        window.receivedToken = null
      }
      // クーポン一覧と同じなので一旦apiTypeを3に設定する
      this.actionRequestToken({
        apiType: '3',
        acc_time: accTime
      })
    } catch (e) {
      console.log(e)
    }
  },
  computed: {
    ...mapGetters({
      prizes: 'Prize/prizes'
    }),
    rankLabel: function() {
      return function(cardType) {
        return {
          0: 'ブロンズランク',
          1: 'シルバーランク',
          2: 'ゴールドランク',
          3: 'プラチナランク',
          4: 'ダイアモンドランク'
        }[cardType]
      }
    },
    rankColor: function() {
      return function(cardType) {
        return {
          0: 'bronze',
          1: 'silver',
          2: 'gold',
          3: 'platinium',
          4: 'diamond'
        }[cardType]
      }
    },
    rankTitle: function() {
      return function(cardType) {
        return {
          0: require(`../assets/img/prizes/rank_bronze.png`),
          1: require(`../assets/img/prizes/rank_silver.png`),
          2: require(`../assets/img/prizes/rank_gold.png`),
          3: require(`../assets/img/prizes/rank_platinium.png`),
          4: require(`../assets/img/prizes/rank_diamond.png`)
        }[cardType]
      }
    }
  },
  methods: {
    ...mapActions('Prize', ['actionFetchPrizes']),
    ...mapActions('Native', ['actionRequestToken']),
    async fetchPrizeList(token, accTime, userId) {
      try {
        await this.actionFetchPrizes({
          token: token,
          accTime: accTime,
          userId: userId
        })
        var rankedPrizes = []
        var count = 0
        for (var prize of this.prizes) {
          if (!rankedPrizes[prize.card_type]) {
            rankedPrizes[prize.card_type] = []
          }
          rankedPrizes[prize.card_type].push(prize)
          count++
          if (count >= 25) {
            break
          }
        }
        this.currentPrizes = rankedPrizes
      } catch (e) {
        this.errorMessage = e.message
        this.errorTitle = 'エラー' + e.code
        this.errorCode = e.code
        this.isError = true
        console.error(e)
      }
    },
    tapPrize(id, caption) {
      try {
        this.trackEvent(FactoryTrack.createCoupon(id, caption))
      } catch (e) {
        console.log(e)
      }
      console.log(window.navigator.onLine)
      if (window.navigator.onLine) {
        this.actionCallCupon(id)
      } else {
        console.log('off line')
        this.action_ToggleModal(true)
        this.errorMessage = '通信環境の良いところで、再度お試しください。'
        this.errorTitle = 'ネットワーククエラー'
        this.errorCode = '0000000'
        this.isError = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.prizes {
  width: 100%;

  .container {
    padding-top: 8px;

    ul {
      padding: 0 10px;
      list-style: none;
    }

    li {
      .title {
        margin: 18px 0;
      }

      &.rank_title {
        margin-bottom: 4px;
        color: white;

        img {
          width: 100%;
        }
      }

      .rank_item {
        display: flex;

        .image {
          flex: 0 0 100px;
          overflow: hidden;
          height: 78px;
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;

          img {
            max-width: 100px;
            width: 100%;
            // height: 100%;
          }
        }

        .detail {
          flex-grow: 1;
          text-align: left;

          .title {
            display: inline-block;
            margin: 0 10px;
            padding: 0 20px;
            border-radius: 16px;
            color: white;
            height: 26px;
            font-size: 3.6vw;
            background-color: #d6ab3b;

            > div {
              display: flex;
              flex-wrap: wrap;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              height: 100%;

              .icon-stamp::before {
                //font-size: 3.7vw;
                margin-right: 2px;
              }
            }
          }

          .caption {
            margin: 4px 10px;
            text-align: left;
            color: #6c402a;
            font-weight: bold;
          }
        }
      }

      hr {
        margin: 8px 0;
      }
    }

    p {
      margin: 0 16px 16px;
      font-size: 12px;
      text-align: left;
      color: #7e7b74;
    }
  }
}

.freepass_container {
  margin: 8px 0;
}

.freepass {
  padding: 8px;
  background-color: #d9b95a;

  .title {
    background-color: var(--accent-color) !important;

  }
}

.prizes .container .title > p {
  font-family: HiraKakuPro-W6;
  font-size: 19px;
  font-weight: bold;
  line-height: 1;
  color: #602209;
}

.prizes .container .title > img {
  max-height: 26px;
  padding-right: 9px;
  border-radius: 4px 0px 0px 4px;
}

.prizes .container .list-faq .item-faq {
  width: 100%;
  padding: 0px 10px 8px 10px;
}

.prizes .container .list-faq .item-faq img {
  border-radius: 4px 0 0 4px;
}

.prizes .container .list-faq .item-faq .description {
  width: 100%;
  border-radius: 0px 4px 4px 0px;
  box-shadow: 0 0 1.5px 0 rgba(0, 0, 0, 0.15);
  background-color: #ffffff;
  padding: 10px;
}

.prizes .container .list-faq .item-faq .description p {
  font-family: HiraKakuPro-W6;
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #602209;
}

.prizes .container .search {
  background-color: var(--background-color);
  margin: 0 10px;
}

.prizes .container .search .router {
  width: 32%;
  background: #ffffff;
  border-radius: 4px;
}

.prizes .container .search .router .item-search {
  width: 100%;
  background: #ffffff;
  border-radius: 0px 0px 4px 4px;
}

.prizes .container .search .router .item-search > p {
  font-family: HiraKakuPro-W6;
  font-size: 13px;
  font-weight: bold;
  line-height: 1.3;
  text-align: center;
  color: #602209;
  padding: 8px 0px;
}

.prizes .container .search .item-search > img {
  width: 100%;
  border-radius: 4px 4px 0px 0px;
}

.prizes .container .footer {
  padding: 14px 0;
  margin: 20px 10px 0px 10px;
  background-color: #602209;
  border-radius: 6px;
}

.prizes .container .footer > p {
  font-size: 14px;
  font-weight: bold;
  line-height: 1;
  text-align: center;
  color: #ffffff;
}

.flex-column-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.flex-justify-center {
  display: flex;
  justify-content: center;
}

.align-items-center {
  align-items: center;
}

.flex-justify-sb-center {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flex-row-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

a {
  text-decoration: none;
}

/* メールアイコン */
.c_mail {
  padding-left: 25px;
  position: relative;
}

.c_mail::before {
  content: '';
  width: 20px;
  height: 20px;
  background: url('../assets/img/mail.svg') no-repeat;
  background-size: cover;
  position: absolute;
  top: -3px;
  left: 0;
}
</style>
